import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useRegistrationStatusChartsDataContext } from './hooks/useRegistrationStatusChartsDataContext';

export const ChildLabor = () => {
    const { chartData } = useRegistrationStatusChartsDataContext();

    return (
        <Donut
            title={'Trabalho Infantil'}
            subtitles={chartData?.childLabor?.map((item) => item.description)}
            chartData={chartData?.childLabor || []}
            colors={defaultColors.slice(0, chartData?.childLabor?.length) || []}
            height={400}
            className="aligned-container"
        />
    );
};
